import { createActions, createReducer } from 'reduxsauce'

/**
 * Action types & creators
 */
export const { Types, Creators } = createActions({
    removeAdministracaoConsultaContrato: [],
    removeTipoContratoConsultaContrato: [],
    removeTipoCompraConsultaContrato: [],
    removeModalidadeConsultaContrato: [],
    removeExercicioContratoConsultaContrato: [],
    removeNumeroContratoConsultaContrato: [],
    removeObjetoContratoConsultaContrato: [],
    removeCnpjConsultaContrato: [],
    removeCpfConsultaContrato: [],
    removeNomeContratadoContratoConsultaContrato: [],
    removeStatusConsultaContrato: [],
    removeDataValidadeInicialConsultaContrato: [],
    removeDataValidadeFinalConsultaContrato: [],
    removeSituacaoConsultaContrato: [],
    setMostraAplicarFiltroConsultaContrato: [],
    limpaFiltroConsultaContrato: [],
    aplicarFiltroConsultaContrato: ['filtro'],
})

const INITIAL_STATE = {
    administracao: [],
    tipoContrato: [],
    tipoCompra: '',
    modalidade: [],
    exercicioContrato: '',
    numeroContrato: '',
    objetoContrato: '',
    cnpj: '',
    cpf: '',
    nomeContratadoContrato: '',
    dataValidadeInicial: '',
    dataValidadeFinal: '',
    situacao: [],
    status: '',
    mostraAplicarFiltro: false,
}

const removeAdministracao = (state = INITIAL_STATE, action) => {
    state.administracao.splice(state.administracao.indexOf(action.administracao), 1)

    //A lista utiliza referencia
    //Então precisei criar uma nova lista
    //para o select do react atualizar quando remover atributos
    state.administracao = Array.from(state.administracao)
    return { ...state, mostraAplicarFiltro: true }
}

const removeTipoContrato = (state = INITIAL_STATE, action) => {
    state.tipoContrato.splice(state.tipoContrato.indexOf(action.tipoContrato), 1)

    //A lista utiliza referencia
    //Então precisei criar uma nova lista
    //para o select do react atualizar quando remover atributos
    state.tipoContrato = Array.from(state.tipoContrato)
    return { ...state, mostraAplicarFiltro: true }
}

const removeModalidade = (state = INITIAL_STATE, action) => {
    state.modalidade.splice(state.modalidade.indexOf(action.modalidade), 1)

    //A lista utiliza referencia
    //Então precisei criar uma nova lista
    //para o select do react atualizar quando remover atributos
    state.modalidade = Array.from(state.modalidade)
    return { ...state, mostraAplicarFiltro: true }
}

const removeExercicioContrato = (state = INITIAL_STATE, action) => {
    return { ...state, exercicioContrato: '', mostraAplicarFiltro: true }
}

const removeTipoCompra = (state = INITIAL_STATE, action) => {
    return { ...state, tipoCompra: '', mostraAplicarFiltro: true }
}

const removeNumeroContrato = (state = INITIAL_STATE, action) => {
    return { ...state, numeroContrato: '', mostraAplicarFiltro: true }
}

const removeObjetoContrato = (state = INITIAL_STATE, action) => {
    return { ...state, objetoContrato: '', mostraAplicarFiltro: true }
}

const removeNomeContratadoContrato = (state = INITIAL_STATE, action) => {
    return { ...state, nomeContratadoContrato: '', mostraAplicarFiltro: true }
}

const removeDataValidadeInicial = (state = INITIAL_STATE, action) => {
    return { ...state, dataValidadeInicial: '', mostraAplicarFiltro: true }
}

const removeDataValidadeFinal = (state = INITIAL_STATE, action) => {
    return { ...state, dataValidadeFinal: '', mostraAplicarFiltro: true }
}

const removeCnpj = (state = INITIAL_STATE, action) => {
    return { ...state, cnpj: '', mostraAplicarFiltro: true }
}

const removeCpf = (state = INITIAL_STATE, action) => {
    return { ...state, cpf: '', mostraAplicarFiltro: true }
}

const removeSituacao = (state = INITIAL_STATE, action) => {
    return { ...state, situacao: '', mostraAplicarFiltro: true }
}

const removeStatus = (state = INITIAL_STATE, action) => {
    return { ...state, status: '', mostraAplicarFiltro: true }
}

const setMostraAplicarFiltro = (state = INITIAL_STATE, action) => {
    return { ...state, mostraAplicarFiltro: !state.mostraAplicarFiltro }
}

const aplicarFiltro = (state = INITIAL_STATE, action) => {
    action.filtro.mostraAplicarFiltro = false
    return action.filtro
}

const limpaFiltro = (state = INITIAL_STATE, action) => {
    return INITIAL_STATE
}

/**
 * Reducer
 */
export default createReducer(INITIAL_STATE, {
    [Types.REMOVE_ADMINISTRACAO_CONSULTA_CONTRATO]: removeAdministracao,
    [Types.REMOVE_TIPO_CONTRATO_CONSULTA_CONTRATO]: removeTipoContrato,
    [Types.REMOVE_EXERCICIO_CONTRATO_CONSULTA_CONTRATO]: removeExercicioContrato,
    [Types.REMOVE_TIPO_COMPRA_CONSULTA_CONTRATO]: removeTipoCompra,
    [Types.REMOVE_MODALIDADE_CONSULTA_CONTRATO]: removeModalidade,
    [Types.REMOVE_NUMERO_CONTRATO_CONSULTA_CONTRATO]: removeNumeroContrato,
    [Types.REMOVE_OBJETO_CONTRATO_CONSULTA_CONTRATO]: removeObjetoContrato,
    [Types.REMOVE_CPF_CONSULTA_CONTRATO]: removeCpf,
    [Types.REMOVE_CNPJ_CONSULTA_CONTRATO]: removeCnpj,
    [Types.REMOVE_DATA_VALIDADE_INICIAL_CONSULTA_CONTRATO]: removeDataValidadeInicial,
    [Types.REMOVE_DATA_VALIDADE_FINAL_CONSULTA_CONTRATO]: removeDataValidadeFinal,
    [Types.REMOVE_NOME_CONTRATADO_CONTRATO_CONSULTA_CONTRATO]: removeNomeContratadoContrato,
    [Types.REMOVE_SITUACAO_CONSULTA_CONTRATO]: removeSituacao,
    [Types.REMOVE_STATUS_CONSULTA_CONTRATO]: removeStatus,
    [Types.SET_MOSTRA_APLICAR_FILTRO_CONSULTA_CONTRATO]: setMostraAplicarFiltro,
    [Types.LIMPA_FILTRO_CONSULTA_CONTRATO]: limpaFiltro,
    [Types.APLICAR_FILTRO_CONSULTA_CONTRATO]: aplicarFiltro,
})
